import type { SVGProps } from 'react';
import * as React from 'react';

/* AUTOGENERATED: DO NOT EDIT */
import _styles from '../logo.module.css';
export const FigmaIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <path
      fill="#000"
      fillRule="evenodd"
      d="M5.47 7.18A3.4 3.4 0 0 1 4 4.36 3.3 3.3 0 0 1 7.23 1h5.54A3.3 3.3 0 0 1 16 4.36a3.4 3.4 0 0 1-1.47 2.82A3.4 3.4 0 0 1 16 10a3.3 3.3 0 0 1-3.23 3.36h-.06c-.84 0-1.61-.33-2.19-.89v3.14c0 1.87-1.48 3.39-3.27 3.39A3.3 3.3 0 0 1 4 15.64a3.4 3.4 0 0 1 1.47-2.82A3.4 3.4 0 0 1 4 10a3.4 3.4 0 0 1 1.47-2.82M10.52 10c0 1.26.98 2.28 2.19 2.28h.06c1.2 0 2.19-1.02 2.19-2.28s-.98-2.28-2.2-2.28h-.05A2.23 2.23 0 0 0 10.52 10M9.48 7.72H7.23A2.23 2.23 0 0 0 5.04 10c0 1.25.98 2.27 2.18 2.28h2.26zm-2.25 5.64a2.23 2.23 0 0 0-2.19 2.28c0 1.25 1 2.27 2.2 2.27a2.3 2.3 0 0 0 2.24-2.3v-2.25zm2.25-6.72H7.23a2.23 2.23 0 0 1-2.19-2.28c0-1.25.98-2.27 2.2-2.27h2.24zm3.29 0h-2.25V2.09h2.25c1.2 0 2.19 1.02 2.19 2.27 0 1.26-.98 2.28-2.2 2.28"
      clipRule="evenodd"
    />
  </svg>
);
